<div class="c-card c-content c-content--xxl u-wrapper" [ngStyle]="!vm.isInitialized && {'min-height': '200px'}">
	<div *ngIf="vm.isInitialized">
		<p class="c-text c-text--spaced u-osb-md">{{ 'Symptom_Check.Factors.Intro' | translate }}</p>
		<form name="vm.form" class="c-form">
			<fieldset class="c-content c-content--border-bottom u-no-ph" *ngFor="let factor of vm.factors ; let $parentIndex=index">
				<div class="o-grid o-grid--wrap">
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-40@md-and-up u-no-p">
						<legend class="c-text u-osb-md@up-to-md">{{ factor.riskFactor.common_name }}</legend>
					</div>
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-60@md-and-up u-no-p">
						<div class="c-form__group u-no-m" [ngClass]="{'c-form__group--error': vm.submitted && vm.invalids[factor.riskFactor.id]}">
							<div class="o-grid o-grid--wrap">
								<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up u-no-p@up-to-md" *ngFor="let option of vm.groupChoiceIds ; let $index=index ; let $last = last" [ngClass]="{'u-osb-sm@up-to-md': !$last}">
									<label class="c-radio">
										<input type="radio" name="{{factor.riskFactor.id}}" [(ngModel)]="vm.evidence[factor.riskFactor.id]" [value]="option" [required]="!vm.evidence[factor.riskFactor.id]" (click)="updateInvalids(factor.riskFactor.id)">
										<span id="riskFactorRadioButtonLabel{{$parentIndex}}-{{$index}}">{{ vm.groupChoiceOptions[option] }}</span>
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
			</fieldset>
		</form>
		
		<div class="o-grid u-ost-md">
			<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-pl">
				<button id="backButton" class="c-button c-button--link c-button--fit c-button--lg" type="button" (click)="vm.handleBack()">{{ 'Common.Back' | translate }}</button>
			</div>
			<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-fixed@md-and-up u-no-pr">
				<button id="submitButton" class="c-button c-button--s1 c-button--fit c-button--lg" type="button" (click)="vm.handleSubmit()">{{ 'Common.Next' | translate }}</button>
			</div>
		</div>
	</div>
	<loader-overlay *ngIf="!vm.isInitialized"></loader-overlay>
</div>
